import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';
import { mailConversationReadingPaneRouteEntryHandler } from './mailConversationReadingPaneRouteHandler';
import { mailItemViewReadingPaneRouteEntryHandler } from './mailItemReadingPaneRouteHandler';

export interface MailReadingPaneRouteParameters {
    folderId: string;
    conversationId: string;
    itemId: string;
    immutableItemId: string;
}

/**
 * This intermediate route handler redirects user to either one of Conversation or Item Reading Pane,
 * depending on the user's preferred List View mode.
 *
 * Primary use case:
 * Push Notifications :- To open appropriate Reading Pane on click of new mail push notification.
 */
export async function mailReadingPaneRouteHandler(
    params: MailReadingPaneRouteParameters
): Promise<void> {
    const modifiedParams = { ...params };
    modifiedParams.itemId = convertRestIdToEwsId(params.itemId);
    modifiedParams.immutableItemId = convertRestIdToEwsId(params.immutableItemId);
    modifiedParams.conversationId = convertRestIdToEwsId(params.conversationId);
    logUsage('WebPush_MailRPLanded', { iId: modifiedParams.itemId }, { isCore: true });
    isItemView()
        ? await mailItemViewReadingPaneRouteEntryHandler({
              ...modifiedParams,
              itemId: isFeatureEnabled('fwk-immutable-ids')
                  ? modifiedParams.immutableItemId
                  : modifiedParams.itemId,
          })
        : await mailConversationReadingPaneRouteEntryHandler(modifiedParams);
}
